import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaLinkedin, FaEnvelope } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Hakkımızda */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-semibold mb-4">Excel Vadisi</h3>
            <p className="text-gray-400 text-sm">
              Excel kullanıcıları için blog yazıları, otomasyonlar ve çözümler sunan profesyonel bir platform.
            </p>
            <p className="text-gray-400 text-xs mt-2">
              Microsoft Excel ve VBA, Microsoft Corporation'ın tescilli ticari markalarıdır.
            </p>
          </div>

          {/* Hızlı Linkler */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-semibold mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors">Blog</Link>
              </li>
              <li>
                <Link to="/automation" className="text-gray-400 hover:text-white transition-colors">Otomasyonlar</Link>
              </li>
              <li>
                <Link to="/qa" className="text-gray-400 hover:text-white transition-colors">Soru & Cevap</Link>
              </li>
            </ul>
          </div>

          {/* Yasal */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-semibold mb-4">Yasal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">Gizlilik Politikası</Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors">Kullanım Koşulları</Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-gray-400 hover:text-white transition-colors">Çerez Politikası</Link>
              </li>
              <li>
                <Link to="/legal-notice" className="text-gray-400 hover:text-white transition-colors">Yasal Uyarı</Link>
              </li>
            </ul>
          </div>

          {/* İletişim */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-semibold mb-4">İletişim</h3>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-400 hover:text-white transition-colors">
                <FaEnvelope className="mr-2" />
                <a href="mailto:info@excelvadisi.com">
                  info@excelvadisi.com
                </a>
              </li>
              <li className="flex items-center text-gray-400 hover:text-white transition-colors">
                <FaInstagram className="mr-2" />
                <a 
                  href="https://www.instagram.com/excelvbamakro/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Instagram
                </a>
              </li>
              <li className="flex items-center text-gray-400 hover:text-white transition-colors">
                <FaLinkedin className="mr-2" />
                <a 
                  href="https://linkedin.com/company/excelvadisi" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="text-center space-y-4">
            <p className="text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} Excel Vadisi. Tüm hakları saklıdır.
            </p>
            <p className="text-gray-500 text-xs max-w-2xl mx-auto">
              Bu site eğitim ve bilgi paylaşımı amacıyla oluşturulmuştur. Sitede yer alan içerikler telif hakkı kapsamında korunmaktadır.
              İzinsiz kopyalanması ve kullanılması yasaktır.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 